import { useQuery } from "@apollo/client";
import { FiZap } from "react-icons/fi";

import { GET_TRENDING_CLIPS } from "MVVM/GraphQL/homepage";
import { formatNumber } from "MVVM/Utilities/Clip";
import {
  WidgetCard,
  WidgetHeader,
  WidgetTag,
  WidgetTitle,
} from "../styledComponents";
import {
  ItemMeta,
  ItemText,
  ItemTitle,
  List,
  RankBadge,
  Row,
  Thumbnail,
} from "./styledComponents";

interface ITrendingClip {
  id: string;
  shareId: string;
  title: string | null;
  username: string;
  views: number;
  thumbnailUrl: string | null;
}

const TRENDING_LIMIT = 3;

export const TrendingNowWidget = () => {
  const { data, loading, error } = useQuery(GET_TRENDING_CLIPS, {
    variables: { limit: TRENDING_LIMIT },
    fetchPolicy: "cache-and-network",
  });

  const clips: ITrendingClip[] = data?.clipsNew?.nodes ?? [];

  if (loading || error || clips.length === 0) return null;

  return (
    <WidgetCard>
      <WidgetHeader>
        <WidgetTitle>
          <FiZap size={15} />
          Trending now
        </WidgetTitle>
        <WidgetTag>CS2</WidgetTag>
      </WidgetHeader>

      <List>
        {clips.map((clip, index) => (
          <Row key={clip.id} to={`/clip/${clip.shareId}`}>
            <RankBadge>{index + 1}</RankBadge>
            <Thumbnail $src={clip.thumbnailUrl ?? undefined} />
            <ItemText>
              <ItemTitle>{clip.title}</ItemTitle>
              <ItemMeta>
                {clip.username} · {formatNumber(clip.views)} views
              </ItemMeta>
            </ItemText>
          </Row>
        ))}
      </List>
    </WidgetCard>
  );
};
